// Images
import { checkedLogo, uncheckedLogo } from '../../../assets/images/formAfterSignUp/index';

// types declarations
import { TCategory } from '../../../types';

// Stylesheets
import styles from '../FormAfterSignUp.module.css';

type TProps = {
  image: JSX.Element;
  checked: boolean;
  header: string;
  description: string;
  category: TCategory;
  setCategory: React.Dispatch<React.SetStateAction<TCategory>>;
};

export default function CategoryCard({
  image,
  checked,
  description,
  header,
  category,
  setCategory,
}: TProps) {
  const borderStyle = checked ? styles.categoryCardActive : styles.categoryCardInactive;
  return (
    <div
      onClick={() => setCategory(category)}
      className={[styles.categoryCard, borderStyle].join(' ')}
    >
      <div className='flex justify-end'>
        <img src={checked ? checkedLogo : uncheckedLogo} alt='checker.png' />
      </div>

      <div className='flex justify-start h-50'>{image}</div>
      <p className={styles.registerHeader}>{header}</p>

      <p className={styles.description}>{description}</p>
    </div>
  );
}
